module.exports = __webpack_public_path__ + "static/media/moon-cloud.9e61180c.svg";